const TYPE = {
    CUSTOM_REPORT: 0,
    SALES_TAX_SUMMARY: 1,
    COLLECTION_DETAILS_BY_TYPE: 2,
    ACCOUNTS_RECEIVABLE: 3,
    AVERAGE_CLIENT_TRANSACTION: 4,
    MONTHLY_PAYMENTS_SUMMARY: 5,
    MONTHLY_BILLING_SUMMARY: 6,
    TOTAL_BILLED_AND_COLLECTED: 13,
    SPECIES_DISTRIBUTION: 17,
    TOTAL_PATIENTS: 18,
    PATIENT_BIRTHDAYS: 19,
    NEW_PATIENTS: 24,
    ACTIVE_PATIENT_LIST: 26,
    ACTIVE_CLIENT_LIST: 27,
    ACTIVE_ENGAGED_CLIENT_LIST: 104,
    INVENTORY_SUMMARY: 28,
    CONTROLLED_SUBSTANCE_LOG: 29,
    EOD_RECONCILIATION: 30,
    SALES_BY_PROVIDER_DETAILS: 33,
    DECEASED_PATIENT_LIST: 34,
    BILLING_DETAIL: 38,
    TRANSACTIONS_DETAIL: 39,
    TIME_SHEET: 42,
    PROFIT_MARGIN: 43,
    CASH_RECONCILIATION: 44,
    OUT_OF_PERIOD_ADJUSTMENTS: 46,
    APPOINTMENT_BY_STATUS: 48,
    INACTIVE_PATIENT_LIST: 50,
    RABIES_SUMMARY: 51,
    ARR: 54,
    PAYMENT_BY_PROVIDER: 65,
    DECLINED_ITEMS: 68,
    SALES_BY_PROVIDER_SUMMARY: 69,
    REMINDERS_DETAIL: 75,
    SALES_BY_APPOINTMENT_TYPE: 78,
    DIAGNOSIS_SUMMARY_LIST: 79,
    SALES_BY_ITEM: 80,
    TRANSACTION_BY_PROVIDER: 82,
    ACTIVE_CLIENTS: 83,
    IN_PROCESS_MEDICAL_NOTES: 84,
    DELETED_TRANSACTIONS: 85,
    RETURNS: 86,
    INVENTORY_ADJUSTMENTS: 87,
    INVENTORY_VALUE_COGS: 88,
    DISCOUNTS_SUMMARY: 89,
    DONATIONS_DETAILS: 90,
    FAILED_EMAILS: 91,
    ITEMS_BY_PRICE_TYPE: 92,
    AR_OUT_OF_PERIOD_SALES: 93,
    CARDS_STORED_ON_FILE: 94,
    UNIQUE_DISPENSING_LOG: 95,
    INVENTORY_ALERTS: 96,
    TIME_SHEETS: 42,
    CHARITABLE_FUND: 97,
    DISCOUNT_DETAILS: 98,
    INVENTORY_LOG: 99,
    APPOINTMENT_LOG: 100,
    CREDITS_APPLIED: 101,
    PENDING_APPOINTMENTS: 81,
    PRODUCTION_CREDIT_BY_SALES: 102,
    PRODUCTION_CREDIT_BY_PAYMENTS: 103,
    ACTIVE_ENGAGED_PATIENT: 105,
    NEW_ENGAGED_CLIENTS: 106,
    PETCARE_CLIENT_LIST: 107,
    APPOINTMENT_DURATION: 108
};

const MESSAGE = {
    ARR_DESCRIPTION:
        "This report calculates the change in accounts receivable for the selected dates (based on the date of each line item), as well as summarized financial data for the same date range."
};

export default {
    TYPE,
    MESSAGE
};
